<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Midas Murders</h1>
<p class="center">
<img alt="Coat.tif" src="image/Coat_fmt.png"/>
</p>
<h3 class="center" style="margin-top:50px;">Pieter Aspe</h3>
<p class="center">Translated by Brian Doyle</p>
<p class="center" style="margin-top:80px;">
<img alt="" src="logo.jpg"/>
</p>
<p class="pagebreak"></p>
<p class="ded"><span class="ital">For my daughters</span></p>
<p class="ded"><span class="ital">Tessa and Mira</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// midas-1.vue?b315e7cc